import { useEffect, useState } from 'react';

const TARGET_TIME = Date.UTC(2025, 11, 18, 12, 30, 0); // 18/12/2025 19:30 GMT+7 = 12:30 UTC

const CountDownFinal = () => {
  const calculateTimeLeft = () => {
    const now = Date.now();
    const diff = TARGET_TIME - now;

    if (diff <= 0) {
      return {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
        finished: true
      };
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n) => n.toString().padStart(2, '0');

    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
      finished: false
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (timeLeft.finished) {
    return (
      <div className="inline-flex flex-col items-center justify-center px-3 py-2 rounded-[14px] bg-[#01240d] border border-[#3ddb62] shadow-[0_0_10px_rgba(0,0,0,0.45)]">
        <span className="text-[12px] md:text-[14px] font-medium text-[#F8E54F] uppercase tracking-wide">
          Chương trình đã kết thúc
        </span>
      </div>
    );
  }

  return (
    <div
      className="inline-flex flex-col items-center w-[300px] h-auto justify-center px-3 py-2"
      style={{
        backgroundImage: 'url(/assets/images/header/bg_countdown.png)',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="flex items-center mt-[28px] gap-[20px] w-[80%] px-5 md:px-2 text-[#0042CB] font-semibold">
        {/* Days */}
        <div className="flex flex-col items-center">
          <div className="min-w-[32px] md:min-w-[40px] px-1 py-[2px] md:py-[4px] rounded-[8px] text-center text-[14px] md:text-[18px] leading-none">
            {timeLeft.days}
          </div>
          <span className="text-[9px] md:text-[10px] uppercase text-[##0042CB]">Ngày</span>
        </div>

        {/* Hours */}
        <div className="flex flex-col items-center">
          <div className="min-w-[28px] md:min-w-[34px] px-1 py-[2px] md:py-[4px] rounded-[8px]  text-center text-[14px] md:text-[18px] leading-none">
            {timeLeft.hours}
          </div>
          <span className="text-[9px] md:text-[10px] uppercase text-[#0042CB]">Giờ</span>
        </div>

        {/* Minutes */}
        <div className="flex flex-col items-center">
          <div className="min-w-[28px] md:min-w-[34px] px-1 py-[2px] md:py-[4px] rounded-[8px]  text-center text-[14px] md:text-[18px] leading-none">
            {timeLeft.minutes}
          </div>
          <span className="text-[9px] md:text-[10px] uppercase text-[#0042CB]">Phút</span>
        </div>

        {/* Seconds */}
        <div className="flex flex-col items-center">
          <div className="min-w-[28px] md:min-w-[34px] px-1 py-[2px] md:py-[4px] rounded-[8px] text-center text-[14px] md:text-[18px] leading-none">
            {timeLeft.seconds}
          </div>
          <span className="text-[9px] md:text-[10px] uppercase text-[#0042CB]">Giây</span>
        </div>
      </div>
    </div>
  );
};

export default CountDownFinal;
